/**
 * 设备的信号
 */

export const DEVICEBASE_SINGAL = {
    // 布置设备的信号
    onAssembleDevice: "onAssembleDevice",
    // 布置设备完成的信号
    onAssembleDeviceFinish: "onAssembleDeviceFinish",
    // 数据线连接的信号
    onAssembleCable: "onAssembleCable",
    // 数据线连接完成的信号
    onAssembleCableFinish: "onAssembleCableFinish",
    // 编辑数据线头尾设备的信号
    onUpadteCableEnd: "onUpadteCableEnd",
    // 编辑数据线头尾设备完成的信号
    onUpadteCableEndFinish: "onUpadteCableEndFinish",
}